import type { DrawerFilter, FilterState } from './FilterAccordion'
import { FilterAccordion } from './FilterAccordion'

/**
 * Filter drawer content props
 */
export interface FilterDrawerContentProps {
  /** Array of filter configurations to display */
  filters: DrawerFilter[]
  /** Current filter state */
  selectedFilters: FilterState
  /** Function to update the filter state */
  setSelectedFilters: (filters: FilterState) => void
}

/**
 * A generic component for rendering filter accordions in a drawer
 */
export const MoiaFilterDrawerContent = ({
  filters,
  selectedFilters,
  setSelectedFilters,
}: FilterDrawerContentProps) => {
  return (
    <>
      {filters
        .filter(filter => filter.options.length > 0)
        .map(filter => (
          <FilterAccordion
            key={filter.id}
            filter={filter}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />
        ))}
    </>
  )
}
